var _path, _circle, _circle2, _path2, _circle3, _circle4, _path3, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.69 21.6639C107.737 9.57619 100.172 16.4889 97.9165 22.4275C90.5195 16.1133 82.9302 22.3484 84.9165 27.752C76.3469 28.8795 78.4163 38.4277 82.7945 40.3814C77.0212 43.9896 80.5395 53.0103 87.9813 51.2062C87.4165 57.9275 92.9165 58.4275 97.002 54.1379C102.417 62.9277 108.917 59.9277 111.435 54.1379C115.404 59.9111 122.034 56.167 122.485 52.1077C132.917 54.9277 131.917 45.4277 129.927 42.185C136.917 33.9277 132.709 28.203 125.643 27.752C127.447 15.8447 117.825 18.4313 113.69 21.6639Z",
    fill: "#23D0C7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.9317,
    cy: 66.9317,
    r: 2.93171,
    fill: "#23D0C7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.0296,
    cy: 75.0296,
    r: 2.02965,
    fill: "#23D0C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.69 84.6639C103.737 72.5762 96.1717 79.4889 93.9165 85.4275C86.5195 79.1133 78.9302 85.3484 80.9165 90.752C72.3469 91.8795 74.4163 101.428 78.7945 103.381C73.0212 106.99 76.5395 116.01 83.9813 114.206C83.4165 120.927 88.9165 121.427 93.002 117.138C98.4165 125.928 104.917 122.928 107.435 117.138C111.404 122.911 118.034 119.167 118.485 115.108C128.917 117.928 127.917 108.428 125.927 105.185C132.917 96.9277 128.709 91.203 121.643 90.752C123.447 78.8447 113.825 81.4313 109.69 84.6639Z",
    fill: "#23D0C7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.9317,
    cy: 128.932,
    r: 2.93171,
    fill: "#23D0C7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.0296,
    cy: 136.03,
    r: 2.02965,
    fill: "#23D0C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6902 47.6639C47.7366 35.5762 40.1717 42.4889 37.9165 48.4275C30.5195 42.1133 22.9302 48.3484 24.9165 53.752C16.3469 54.8795 18.4163 64.4277 22.7945 66.3814C17.0212 69.9896 20.5395 79.0103 27.9813 77.2062C27.4165 83.9275 32.9165 84.4275 37.002 80.1379C42.4165 88.9277 48.9165 85.9277 51.4351 80.1379C55.4041 85.9111 62.0344 82.167 62.4854 78.1077C72.9165 80.9277 71.9165 71.4277 69.9274 68.185C76.9165 59.9277 72.7088 54.203 65.6426 53.752C67.4468 41.8447 57.8247 44.4313 53.6902 47.6639Z",
    fill: "#23D0C7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9317,
    cy: 90.9317,
    r: 2.93171,
    fill: "#23D0C7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0296,
    cy: 97.0296,
    r: 2.02965,
    fill: "#23D0C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen1);
export default __webpack_public_path__ + "static/media/open 1.31f2ec05aa8c3fc7e6ab2edae1fb71b2.svg";
export { ForwardRef as ReactComponent };